import { todayUsDate } from "../../utils/date-validation";
import type { SubmissionForm } from "../../types/submission";

/** Initial form-side detail used when the SubmissionLayout is mounted
 *  in create mode (route `/submissions/new`). Leaves default to empty
 *  (so the UW Information form's zod schema surfaces validation on
 *  submit) — except Date of Submission, which defaults to today. The
 *  id stays empty until the server returns one — that's
 *  how the page knows whether to POST or PATCH on save. */
export function blankSubmissionForm(): SubmissionForm {
    return {
        id: "",
        status: "Draft",
        assignee: null,
        approver: null,
        isBorReceived: null,
        dropboxUrl: "",
        probabilityToBind: "",
        // No server record yet in create mode → no last-updated timestamp.
        updatedAt: "",
        accountBasics: {
            title: "",
            fni: "",
            mailingAddress: "",
            businessDescription: "",
            type: "",
            renewalDate: "",
            expirationDate: "",
            // Nice-to-have: a new submission defaults the Date of Submission
            // to today (editable / clearable by the user).
            submissionDate: todayUsDate(),
            expiringPremium: "",
            expiringDeductible: "",
            accountManagerName: "",
            accountManagerEmail: "",
        },
        brokerage: {
            brokerId: "",
            brokerEmail: "",
            brokerName: "",
            brokerageName: "",
            brokerageAddress: "",
        },
        geminiContacts: {
            riskManagerName: "",
            riskManagerEmail: "",
            riskManagerPhone: "",
            administratorName: "",
            administratorEmail: "",
            administratorPhone: "",
            administratorDuration: "",
            administratorDurationUnit: "years",
        },
        note: "",
        namedInsureds: [],
        additionalInsureds: [],
        locations: [],
        schedule: {
            rateUnadjusted: "",
            rateAdjustedOccupancy: "",
            relativity: { skilled: "", assisted: "", independent: "", additionalExposure: "" },
            facilities: [],
            stateDistribution: [],
        },
    };
}
